export default __webpack_public_path__ + "d27ec0bb7873dc3fa9e2e45713486846.png";